<template>
  <v-list subheader>
    <RecycleScroller
      :items="filteredList"
      :item-size="125"
      style="height: 60vh"
      class="px-3 pt-4 pb-5"
    >
      <template v-slot="{ item }">
        <v-list-tile
          :key="item.id"
          avatar
          class="ml-1 mb-3 elevation-1 grey lighten-5 buttonLeft elementVisor user"
        >
          <v-list-tile-avatar
            :class="
              item.door && item.door.color
                ? 'list-title-avatar-custom bordered'
                : 'list-title-avatar-custom'
            "
            :style="
              item.door && item.door.color
                ? `border-color:${item.door.color}`
                : ''
            "
          >
            <v-badge left color="primary" overlap>
              <template v-slot:badge>
                <div v-if="item.badge === true">
                  <v-menu
                    v-model="item.menu"
                    :close-on-content-click="false"
                    :nudge-width="350"
                    offset-x
                  >
                    <template v-slot:activator="{ on }">
                      <span @click="getRound(item.idRound)" v-on="on">R</span>
                    </template>
                    <watchRound
                      :round="selected.round"
                      @close="
                        item.menu = false
                        selected.round = null
                      "
                    ></watchRound>
                  </v-menu>
                </div>
                <div v-else-if="item.isThird === true">
                  <span>T</span>
                </div>
              </template>
              <v-avatar class="mt-2 ml-2" :size="60">
                <img
                  v-if="
                    item.student.imageStorage &&
                    item.student.imageStorage.miniObjUrl &&
                    item.student.imageStorage.miniObjUrl.trim()
                  "
                  :src="item.student.imageStorage.miniObjUrl"
                />
                <img
                  v-else
                  :src="require('@/assets/panel/home/SKLB-Alumnos.png')"
                />
              </v-avatar>
            </v-badge>
          </v-list-tile-avatar>
          <v-list-tile-content
            :class="
              item.door && item.door.color
                ? 'pl-2 pr-1 bordered-flat'
                : 'pl-2 pr-1'
            "
            @click="toogleToolTips(item)"
            :style="
              item.door && item.door.color
                ? `border-color:${item.door.color}`
                : ''
            "
          >
            <v-tooltip bottom style="width: 100%" v-model="item.toolTipSel">
              <div slot="activator" class="headline text-truncate">
                {{ item.student.firstName + ' ' + item.student.lastName }}
              </div>
              <ul
                style="list-style: none; padding: 0; font-size: 16px"
                @click="toogleToolTips(item)"
              >
                <li style="font-size: 18px; font-weight: bold">
                  {{ item.student.firstName + ' ' + item.student.lastName }}
                </li>
                <li>----------</li>
                <li>
                  {{
                    item.door.doorName + ', ' + formatTime(item.requestedTime)
                  }}
                </li>
                <li>
                  {{
                    item.personRequesting ||
                    item.parent.firstName + ' ' + item.parent.lastName
                  }}
                </li>
                <li v-if="item.car && item.car.id">
                  {{
                    item.car.model +
                    ', ' +
                    item.car.color +
                    ' - ' +
                    item.car.plates
                  }}
                </li>
                <li v-else>Caminando</li>
              </ul>
            </v-tooltip>
            <v-list-tile-sub-title one-line>
              {{ 'Grupo ' + item.student.gg.grade + item.student.gg.group }}
            </v-list-tile-sub-title>
            <v-list-tile-sub-title one-line>
              {{ item.door.doorName + ', ' + formatTime(item.requestedTime) }}
            </v-list-tile-sub-title>
            <v-list-tile-sub-title one-line>
              {{
                item.personRequesting ||
                item.parent.firstName + ' ' + item.parent.lastName
              }}
            </v-list-tile-sub-title>

            <v-list-tile-sub-title v-if="item.car && item.car.id" one-line>
              {{ carDescription(item.car) }}
            </v-list-tile-sub-title>
            <v-list-tile-sub-title v-else one-line>
              {{ 'Caminando' }}
            </v-list-tile-sub-title>
          </v-list-tile-content>

          <v-list-tile-action
            style="border-radius: 5px; padding: 0px; min-width: 88px"
          >
            <v-btn
              class="listButton"
              :loading="item.loading"
              block
              depressed
              large
              :color="item.status == 'R' ? 'info' : 'warning'"
              :disabled="permits['CALLED_VISOR'] ? false : true"
              @click="send(item)"
            >
              {{ item.status == 'R' ? 'Enviar' : 'En camino' }}
              <template v-slot:loader>
                <v-progress-circular
                  :rotate="-90"
                  :value="item.progressValue * 20"
                  color="gradiente"
                  >{{ item.progressValue }}
                </v-progress-circular>
              </template>
            </v-btn>
            <v-expand-transition>
              <v-btn
                @click="undoSend(item)"
                v-if="item.loading && !item.uLoading && !item.begun"
                small
                depressed
                large
                >Deshacer
              </v-btn>
            </v-expand-transition>
          </v-list-tile-action>
        </v-list-tile>
      </template>
    </RecycleScroller>
  </v-list>
</template>

<script>
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import watchRound from './WatchRound'
export default {
  components: {
    watchRound,
  },
  props: {
    list: Array,
    permits: Array,
  },
  data: () => ({
    menu: false,
    seeList: false,
    selected: {
      round: null,
    },
  }),
  methods: {
    carDescription(car) {
      if (car.model == car.color && car.color == car.plates) return car.model

      return car.model + ', ' + car.color + ' - ' + car.plates
    },
    toogleToolTips(item) {
      item.toolTipSel = !item.toolTipSel
      if (item.toolTipSel) {
        this.filteredList.forEach((i) => {
          if (item.id != i.id) {
            i.toolTipSel = false
          }
        })
      }
    },
    hideAllToolTips() {
      this.filteredList.forEach((i) => {
        i.toolTipSel = false
      })
    },
    formatTime(time) {
      return (
        (new Date(time).getHours() % 12 || 12) +
        ':' +
        (new Date(time).getMinutes() < 10
          ? '0' + new Date(time).getMinutes()
          : new Date(time).getMinutes()) +
        (new Date(time).getHours() >= 12 ? ' p.m.' : ' a.m.')
      )
    },
    undoSend(item) {
      this.$emit('unDo', item)
    },
    send(item) {
      this.$emit('send', item)
    },
    getRound(id) {
      this.$store
        .dispatch('round/getRound', { id: id })
        .then((response) => {
          this.selected.round = response.data.entity
        })
        .catch((error) => {
          this.selected.round = { id: 0 }
        })
    },
  },
  computed: {
    filteredList() {
      return this.list.map((item) => ({
        menu: false,
        badge: item.idRound != null,
        isThird: item.idThirdQr !== null && item.idThirdQr !== undefined,
        toolTipSel: false,
        ...item,
      }))
    },
  },
  mounted() {},
}
</script>
<style>
.list-title-avatar-custom {
  height: 100%;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bordered {
  border-left: 4px solid;
  border-top-left-radius: 40px !important;
  border-bottom-left-radius: 40px !important;
  border-top: 4px solid;
  border-bottom: 4px solid;
}

.bordered-flat {
  border-top: 4px solid;
  border-bottom: 4px solid;
}
</style>

<style scoped>
::v-deep .v-badge--overlap.v-badge--left .v-badge__badge {
  left: 9px;
  top: 0px;
}
::v-deep .v-list__tile--avatar {
  padding-left: 0px;
  height: 115px !important;
}
</style>
